import { render } from "./App.vue?vue&type=template&id=d508dee8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d508dee8&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__